import { TemplateRef } from '@angular/core';
import { TreeStatusEnum } from '@shared/modules/list/enums/tree-status.enum';
import { CustomTableColumn } from '../interfaces/custom-table-column.interface';

const TOGGLE_MENU_COLUMN_WIDTH = 24;

export interface ListColumnTemplates {
  toggleMenu: TemplateRef<any>;
  columnsSettings: TemplateRef<any>;
  toggleTree: TemplateRef<any>;
  checkbox: TemplateRef<any>;
  checkboxAll: TemplateRef<any>;
}

export function decorateListColumns(columns: CustomTableColumn[], templates: ListColumnTemplates): void {
  for (let i = 0; i < columns.length; i++) {
    const column = columns[i];

    if (column.toggleMenu) {
      column.width = TOGGLE_MENU_COLUMN_WIDTH;
      column.minWidth = TOGGLE_MENU_COLUMN_WIDTH;
      column.maxWidth = TOGGLE_MENU_COLUMN_WIDTH;
      column.cellTemplate = templates.toggleMenu;
      column.headerTemplate = templates.columnsSettings;
      column.cellClass += ' toggle-cell';
    }

    if (column.isTreeColumn) {
      column.treeToggleTemplate = templates.toggleTree;
      column.cellClass += ' tree-cell';
    }

    if (column.checkbox) {
      column.cellTemplate = templates.checkbox;
      column.headerTemplate = templates.checkboxAll;
      column.cellClass += ' checkbox';
    }
  }
}

export function handleTreeActivateEvent<T extends { type: string; row: any; column: CustomTableColumn; event: any }>(
  event: T
): T {
  if ((event.type === 'click' || event.type === 'touchstart') && event.column?.isTreeColumn) {
    const path = event.event.path || (event.event.composedPath && event.event.composedPath());

    for (let i = 0; i <= path.length - 1; i++) {
      if (path[i]?.classList?.contains('datatable-tree-button')) {
        event.type = 'unselect';
      }
    }
  }

  return event;
}

export function buildListRowClass(
  row: any,
  configRowClass: string,
  rowClassFunction?: Function,
  treeDisabled = false
): Record<string, boolean> {
  const rowClass = {
    [configRowClass]: true,
    'tree-row': row.treeStatus === TreeStatusEnum.EXPANDED && !treeDisabled
  };

  if (rowClassFunction) {
    rowClass[rowClassFunction(row)] = true;
  }

  return rowClass;
}

export function sortColumnsByOrder(a: CustomTableColumn, b: CustomTableColumn): number {
  return a.order - b.order;
}

export function identifyColumnByProp(index: number, item: CustomTableColumn) {
  return item.prop;
}
